<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <router-link to="/cart">{{ $t("购物车") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{ $t("结算") }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card>
            <div class="container">
              <div class="md-title title-category">{{ $t("收件人资料") }}</div>
            </div>

            <md-card-content>
              <form novalidate class="md-layout" @submit.prevent="validateUser">
                <div class="md-layout-item">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.name">
                        <label for="name">{{ $t("姓名") }}</label>
                        <md-input
                          name="name"
                          id="name"
                          v-model="order.name"
                          @focus="clearError('name')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.email">
                        <label for="email">{{ $t("电邮") }}</label>
                        <md-input
                          name="email"
                          id="email"
                          v-model="order.email"
                          @focus="clearError('email')"
                        />
                      </md-field>
                    </div>

                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.phone">
                        <label for="phone">{{ $t("电话") }}</label>
                        <md-input
                          name="phone"
                          id="phone"
                          v-model="order.phone"
                          @focus="clearError('phone')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.state">
                        <label for="state">{{ $t("省") }}</label>
                        <md-select
                          name="state"
                          id="state"
                          v-model="order.state"
                          @focus="clearError('state')"
                        >
                          <md-option
                            v-for="(state_option, si) in state_options"
                            :key="si"
                            :value="state_option"
                          >{{state_option}}</md-option>
                        </md-select>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-small-size-100"
                      v-if="(order.state && order.state != '香港特别行政区')"
                    >
                      <md-field :class="order_error.city">
                        <label for="city">{{ $t("市") }}</label>
                        <md-select
                          name="city"
                          id="city"
                          v-model="order.city"
                          @focus="clearError('city')"
                        >
                          <md-option
                            v-for="(city_option, si) in city_options"
                            :key="si"
                            :value="city_option"
                          >{{city_option}}</md-option>
                        </md-select>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-small-size-100"
                      v-if="(order.state && order.state != '香港特别行政区')"
                    >
                      <md-field :class="order_error.address_1">
                        <label for="address_1">{{ $t("区") }}</label>
                        <md-select
                          name="address_1"
                          id="address_1"
                          v-model="order.address_1"
                          @focus="clearError('address_1')"
                        >
                          <md-option
                            v-for="(district_option, si) in district_options"
                            :key="si"
                            :value="district_option"
                          >{{district_option}}</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.address_2">
                        <label for="address_2">{{ $t("详细地址") }}</label>
                        <md-textarea
                          name="address_2"
                          id="address_2"
                          md-autogrow
                          v-model="order.address_2"
                          @focus="clearError('address_2')"
                        ></md-textarea>
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter" v-if="(order.state && order.state != '香港特别行政区')">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.china_id">
                        <label for="china_id">{{ $t("身份证明号码") }}</label>
                        <md-input
                          name="china_id"
                          id="china_id"
                          v-model="order.china_id"
                          @focus="clearError('china_id')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter" v-if="(order.state && order.state != '香港特别行政区')">
                    <div class="md-layout-item md-small-size-100">
                      <md-field>
                        <label>{{ $t("身份证明文件 (正面)") }}</label>
                        <md-file accept="image/*" />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter" v-if="(order.state && order.state != '香港特别行政区')">
                    <div class="md-layout-item md-small-size-100">
                      <md-field>
                        <label>{{ $t("身份证明文件 (反面)") }}</label>
                        <md-file accept="image/*" />
                      </md-field>
                    </div>
                  </div>
                </div>
              </form>
            </md-card-content>
          </md-card>

          <md-card>
            <div class="container">
              <div class="md-title title-category">{{ $t("订单详情") }}</div>
            </div>

            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>{{ $t("产品") }}</md-table-head>
                  <md-table-head md-numeric>{{ $t("价钱") }}</md-table-head>
                  <md-table-head md-numeric>{{ $t("数量") }}</md-table-head>
                  <md-table-head md-numeric>{{ $t("小计") }}</md-table-head>
                </md-table-row>

                <md-table-row v-for="(product, product_key) in display_products" :key="product_key">
                  <md-table-cell>{{product.name_cn}}</md-table-cell>
                  <md-table-cell md-numeric>${{product.price}}</md-table-cell>
                  <md-table-cell md-numeric>
                    <div class="container-numeric">{{product.quantity}}</div>
                  </md-table-cell>
                  <md-table-cell md-numeric>
                    <div class="container-numeric">
                      <div>${{product.sub_total}}</div>
                    </div>
                  </md-table-cell>
                </md-table-row>

                <md-table-row v-if="discount_rate">
                  <md-table-cell colspan="3" md-numeric>{{ $t("折扣") }}</md-table-cell>
                  <md-table-cell>
                    <div class="container-numeric">${{discount_amount}}</div>
                  </md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell colspan="3" md-numeric>{{ $t("总额") }}</md-table-cell>
                  <md-table-cell>
                    <div class="container-numeric">${{total_amount}}</div>
                  </md-table-cell>
                </md-table-row>
              </md-table>

              <div class="md-layout">
                <div class="md-layout-item md-size-20 md-small-size-50">
                  <div class="container-flex_center">
                    <md-field md-inline>
                      <label for="coupon_code">{{ $t("优惠码") }}</label>
                      <md-input
                        name="coupon_code"
                        v-model="txt_discount_code"
                        id="coupon_code"
                        :disabled="(discount_rate != false)"
                      />
                    </md-field>
                  </div>
                </div>

                <div class="container-add_to_cart">
                  <!-- <router-link :to="{ name: 'cart', params: {}}"> -->
                  <md-button
                    class="md-primary"
                    v-if="!discount_rate"
                    @click="onClickRedeem"
                  >{{ $t("應用") }}</md-button>
                  <md-button
                    class="md-primary"
                    v-if="discount_rate"
                    @click="onClickCancelRedeem"
                  >{{ $t("取消優惠碼") }}</md-button>
                  <!-- </router-link> -->
                </div>

                <div class="container-add_to_cart">
                  <md-button class="md-primary" @click="onShareCart">{{ $t("分享") }}</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card>
            <div class="container">
              <div class="md-title title-category">{{ $t("付款详情") }}</div>
            </div>

            <md-card-content>
              <div id="dropin-container"></div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100 container-checkout_btn">
                  <md-button type="submit" class="md-primary" @click="onClickPayment">{{ $t("付款") }}</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <md-dialog-alert
      :md-active.sync="show_payment_qr"
      md-title="微信支付"
      :md-content="payment_qr_message"
      md-confirm-text="確定"
    />

    <md-dialog-alert
      :md-active.sync="show_share_link"
      md-title="分享购物车"
      :md-content="str_share_link"
      md-confirm-text="確定"
    />
  </div>
</template>

<script>
export default {
  components: {},
  name: "checkout",
  bodyClass: "checkout-page",
  props: {},
  data() {
    return {
      state_options: [
        "香港特别行政区",
        "台湾省",
        "新疆维吾尔自治区",
        "云南省",
        "河南省",
        "贵州省",
        "海南省",
        "澳门特别行政区",
        "黑龙江省",
        "江西省",
        "内蒙古自治区",
        "四川省",
        "湖南省",
        "安徽省",
        "天津市",
        "天津市",
        "北京市",
        "山东省",
        "湖北省",
        "吉林省",
        "上海市",
        "江苏省",
        "西藏自治区",
        "辽宁省",
        "山西省",
        "河北省",
        "浙江省",
        "甘肃省",
        "重庆市",
        "福建省",
        "广西壮族自治区",
        "青海省",
        "广东省",
        "宁夏回族自治区"
      ],

      city_options: [
        "阿克苏地区",
        "保山市",
        "安阳市",
        "安顺市",
        "白沙黎族自治县",
        "澳门",
        "大庆市",
        "抚州市",
        "阿拉善盟",
        "长沙市",
        "安徽省",
        "天津市",
        "安康市",
        "北京市",
        "滨州市",
        "鄂州市",
        "白城市",
        "上海市",
        "常州市",
        "阿里地区",
        "鞍山市",
        "长治市",
        "香港",
        "保定市",
        "杭州市",
        "白银市",
        "重庆市",
        "福建省",
        "百色市",
        "果洛藏族自治州",
        "潮州市",
        "固原市"
      ],

      district_options: [
        "高淳区",
        "鼓楼区",
        "建邺区",
        "江宁区",
        "溧水区",
        "六合区",
        "南京市",
        "浦口区",
        "栖霞区",
        "秦淮区",
        "玄武区",
        "雨花台区",
        "姑苏区",
        "虎丘区",
        "昆山市",
        "苏州市",
        "太仓市",
        "吴江区",
        "吴中区",
        "相城区"
      ],

      show_payment_qr: false,
      payment_qr_message: "",

      show_share_link: false,
      str_share_link: "",

      order: {
        name: "",
        phone: "",
        email: "",
        state: "",
        city: "",
        address_1: "",
        address_2: "",
        china_id: ""
      },
      order_error: {
        name: "",
        phone: "",
        email: "",
        state: "",
        city: "",
        address_1: "",
        address_2: "",
        china_id: ""
      },
      products: [{}, {}, {}, {}],
      braintree_instance: false,
      txt_discount_code: "",
      discount_rate: false
    };
  },
  methods: {
    async getLocationList() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "location_get.php",
        data: {
          member_id: this.$store.state.member_id
        }
      });

      this.state_options = response.data.state_options;
      this.city_options = response.data.city_options;
      this.district_options = response.data.district_options;

      this.loader.hide();
    },

    verifyChinaID(china_id) {
      let is_valid = true;
      console.log("china_id - " + china_id);

      let digit_weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];

      let remainder_digits = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];

      if (!china_id || china_id == "" || china_id.length != 18) {
        is_valid = false;
      }

      let check_sum = 0;
      let check_digit = false;

      for (let i in china_id) {
        // check if last
        if (i == china_id.length - 1) {
          check_digit = china_id[i];
          break;
        }

        let c_digit = china_id[i];
        let digit_weight = digit_weights[i];

        if (!Number.isInteger(parseInt(c_digit))) {
          is_valid = false;
        }

        check_sum += c_digit * digit_weight;
      }

      let remainder = check_sum % 11;
      let remainder_digit = remainder_digits[remainder];

      if (remainder_digit != check_digit) {
        is_valid = false;
      }

      if (!is_valid) {
        this.order_error["china_id"] = "md-invalid";
      }

      return is_valid;
    },
    async getCart() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_cart_get.php",
        data: {
          member_id: this.$store.state.member_id
        }
      });

      this.products = response.data.products;
      if (response.data.discount_code) {
        this.txt_discount_code = response.data.discount_code.discount_code;
        this.discount_rate = parseFloat(
          response.data.discount_code.discount_rate
        );
      } else {
        this.txt_discount_code = "";
        this.discount_rate = false;
      }

      this.loader.hide();
    },

    clearError(error_id) {
      this.order_error[error_id] = false;
    },

    verifyForm() {
      return true;
      let is_valid = true;
      console.log(this.order);
      for (let i in this.order) {
        if (this.order.state == "香港特别行政区") {
          if (i == "city" || i == "address_1" || i == "china_id") {
            continue;
          }
        }
        if (this.order[i] == "") {
          this.order_error[i] = "md-invalid";
          is_valid = false;
          console.log(i + " is invalid");
        }
      }

      return is_valid;
    },

    onClickPaymentValoot() {
      if (!this.verifyForm()) {
        return;
      }
      if (
        this.order.state != "香港特别行政区" &&
        !this.verifyChinaID(this.order.china_id)
      ) {
        return;
      }

      this.confirmCheckoutValoot();
    },

    async confirmCheckoutValoot() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "valoot_get_qr.php",
        data: {
          member_id: this.$store.state.member_id,
          order: this.order
        }
      });

      console.log(response);

      this.payment_qr_message =
        "<img src='" +
        response.data +
        "' /><br><a target='_blank' href='" +
        response.data +
        "'>或按此付款</a>";
      this.show_payment_qr = true;

      // this.$router.push({ name: "orders", params: {} });
    },

    onClickPayment() {
      if (!this.verifyForm()) {
        console.log("invalid form");
        return;
      }
      if (
        this.order.state != "香港特别行政区" &&
        !this.verifyChinaID(this.order.china_id)
      ) {
        return;
      }
      this.confirmCheckout();
    },

    async confirmCheckout() {
      this.braintree_instance.requestPaymentMethod(async (err, payload) => {
        // Submit payload.nonce to your server

        let response = await this.$http({
          method: "POST",
          baseURL: `${this.$conf.API_HOST}`,
          url: "wx_cart_checkout.php",
          data: {
            member_id: this.$store.state.member_id,
            order: this.order,
            nonce: payload.nonce
          }
        });
        alert("付款成功");
        this.$router.push({ name: "orders", params: {} });
      });
    },

    async startWeChatPay() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_cart_checkout.php",
        data: {
          member_id: this.$store.state.member_id,
          order: this.order
        }
      });

      this.$router.push({ name: "orders", params: {} });
    },

    async getBTToken() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "bt_token_get.php",
        data: {
          member_id: this.$store.state.member_id
        }
      });

      this.bt_token = response.data.clientToken;
    },

    async onClickCancelRedeem() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "cart_cancel_discount_code.php",
        data: {
          member_id: this.$store.state.member_id,
          discount_code: this.txt_discount_code
        }
      });

      this.getCart();
    },

    async onClickRedeem() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "cart_apply_discount_code.php",
        data: {
          member_id: this.$store.state.member_id,
          discount_code: this.txt_discount_code
        }
      });

      if (response.data.msg) {
        alert(response.data.msg);
      }

      this.discount_rate = response.data.discount_rate;
    },

    async onShareCart() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "cart_share.php",
        data: {
          member_id: this.$store.state.member_id
        }
      });

      let share_url = `${this.$conf.SITE_DOMAIN}/#/cart_share/${response.data.share_token}`;

      this.show_share_link = true;
      this.str_share_link = "<div>"+share_url+"</div>";

      // alert(share_url);
    },

    onCopyShareLink() {
      document.execCommand(this.str_share_link);
    }
  },
  computed: {
    total_amount() {
      let total_amount = 0;
      for (let i in this.products) {
        let product = this.products[i];
        total_amount +=
          parseFloat(product.price) * parseFloat(product.quantity);
      }
      let discount_amount = 0;
      if (this.discount_rate) {
        discount_amount = total_amount * this.discount_rate;
      }
      total_amount = total_amount - discount_amount;
      total_amount = this.$numeral(total_amount).format("0,0.0");

      return total_amount;
    },

    discount_amount() {
      if (!this.discount_rate) {
        return 0;
      }
      let total_amount = 0;
      for (let i in this.products) {
        let product = this.products[i];
        total_amount +=
          parseFloat(product.price) * parseFloat(product.quantity);
      }
      let discount_amount = total_amount * this.discount_rate;
      discount_amount = this.$numeral(discount_amount).format("0,0.0");

      return discount_amount;
    },
    display_products() {
      return this.products.map(p => {
        p.sub_total = parseFloat(p.price) * parseFloat(p.quantity);
        p.price = this.$numeral(p.price).format("0,0.0");
        p.sub_total = this.$numeral(p.sub_total).format("0,0.0");
        return p;
      });
    }
  },
  async created() {
    await this.getCart();
  },
  async mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
    await this.getBTToken();
    console.log(this.bt_token);
    braintree.dropin.create(
      {
        // authorization: "sandbox_g42y39zw_348pk9cgf3bgyw2b",
        authorization: this.bt_token,
        selector: "#dropin-container",
        locale: "zh_CN",
        paymentOptionPriority: ["card"]
      },
      (err, instance) => {
        this.braintree_instance = instance;

        // button.addEventListener("click", function() {
        //   instance.requestPaymentMethod(function(err, payload) {
        //     // Submit payload.nonce to your server
        //   });
        // });
      }
    );
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
.img-product {
  height: 150px;
}

.container-checkout_btn {
  display: flex;
  justify-content: flex-end;
}

.md-dialog-content, .md-dialog-content div {
    white-space: pre-wrap;
}

.md-dialog-container{
  width: 100%;
}
</style>